module.exports = "<div class=\"row m-0\">\r\n<div class=\"col-12 main_content_aria\">\r\n<ng-content></ng-content>\r\n</div>\r\n</div>"